import request from '../request'
import { BASE_API } from '../Constant'
// @todo this file name should be product service
const baseUrl = `${BASE_API}category`

function getCategoryData() {
  return request({
    url: `${baseUrl}/categories_product`,
    method: 'GET',
  })
}
function getAllCategory() {
  return request({
    url: `${baseUrl}/index`,
    method: 'GET',
  })
}
function getCategoryById(id) {
  return request({
    url: `${baseUrl}/categories_product_id/${id}`,
    method: 'GET',
  })
}
function getCart(id) {
  return request({
    url: `${baseUrl}/view-order?user_id=${id}`,
    method: 'GET',
  })
}
function deleteCartById(id) {
  return request({
    url: `${baseUrl}/clear-cart-id/${id}`,
    id,
    method: 'POST',
  })
}
function deleteCart(id) {
  return request({
    url: `${baseUrl}/clear-cart?user_id=${id}`,
    id,
    method: 'POST',
  })
}
const CategoriesService = {
    getCategoryData,
    getCart,
    getAllCategory,
    getCategoryById,
    deleteCartById,
    deleteCart
}

export default CategoriesService
